// src/api/hrm/tasks/info.js
import axiosInstance from "../../axiosInstance";

// const base = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
// const BASE_URL = `${base}/hrm/tasks`;

const BASE_URL = "/hrm/tasks";

const buildConfig = (data) => {
  const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
  return {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    timeout: isFormData ? 120_000 : 30_000,
  };
};

/* ---------------------------------------------
 📋 LẤY DANH SÁCH CÔNG VIỆC
---------------------------------------------- */
export const getAllTasks = async (params = {}) => {
  try {
    const res = await axiosInstance.get(BASE_URL, { params });
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Lỗi khi tải danh sách công việc";
    console.error(msg, error);
    throw new Error(msg);
  }
};

/* ---------------------------------------------
 📊 TỔNG HỢP CÔNG VIỆC THEO NHÂN VIÊN (XUẤT EXCEL)
---------------------------------------------- */
export const getTasksExportSummary = async (params = {}) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/export-summary`, { params });
    return res.data;
  } catch (error) {
    const msg =
      error?.response?.data?.message || "Lỗi khi tổng hợp dữ liệu công việc";
    console.error(msg, error);
    throw new Error(msg);
  }
};

// ✅ Lấy danh sách công việc chi tiết theo nhân viên và ngày
export const getTasksByEmployeeAndDate = async (employee_id, work_day, status) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/by-employee-date`, {
      params: { employee_id, work_day, status },
    });
    return response.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "❌ Lỗi khi tải danh sách công việc theo nhân viên và ngày";
    console.error("❌ getTasksByEmployeeAndDate error:", msg, error);
    throw new Error(msg);
  }
};


// Lấy danh sách công việc theo nhân viên và khoảng ngày
export const getTasksByEmployeeByRange = async (employee_id, from_date, to_date) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/by-employee-by-range`, {
      params: { employee_id, from_date, to_date }
    });
    // BE trả về { items: [...] }
    return res.data.items || [];
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể tải công việc theo khoảng ngày";
    console.error("❌ getTasksByEmployeeByRange error:", msg, error);
    throw new Error(msg);
  }
};


/* ---------------------------------------------
 ✅ Hàm chuyên dùng cho popup (load chi tiết công việc theo nhân viên và ngày)
---------------------------------------------- */
export const getTaskDetailsByEmployeeDate = async (employee_id, work_day) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/by-employee-date`, {
      params: { employee_id, work_day },
    });
    // ✅ Chuẩn hóa dữ liệu để luôn trả về array
    if (Array.isArray(res.data)) return res.data;
    if (Array.isArray(res.data.items)) return res.data.items;
    return [];
  } catch (error) {
    console.error("❌ Lỗi lấy chi tiết công việc (popup):", error);
    return [];
  }
};



/* ---------------------------------------------
 👥 LẤY DANH SÁCH CÔNG VIỆC CỦA NHÂN VIÊN CẤP DƯỚI
---------------------------------------------- */
export const getSubordinateTasks = async (work_day, creator_position) => {
  try {
    if (!work_day || !creator_position) {
      throw new Error("Thiếu work_day hoặc creator_position");
    }

    const res = await axiosInstance.get(`${BASE_URL}/subordinates`, {
      params: { work_day, creator_position },
    });

    if (Array.isArray(res.data)) return res.data;
    if (Array.isArray(res.data.items)) return res.data.items;
    return [];
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      "❌ Lỗi khi tải công việc của nhân viên cấp dưới";
    console.error(msg, error);
    return [];
  }
};




/* ---------------------------------------------
 🔍 LẤY CHI TIẾT 1 CÔNG VIỆC
---------------------------------------------- */
export const getTaskById = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Lỗi khi lấy thông tin công việc";
    console.error(msg, error);
    throw new Error(msg);
  }
};

/* ---------------------------------------------
 ➕ TẠO MỚI CÔNG VIỆC
---------------------------------------------- */
export const createTask = async (taskData) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}`, taskData, buildConfig(taskData));
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Lỗi khi thêm công việc";
    console.error(msg, error);
    throw new Error(msg);
  }
};


/* ---------------------------------------------
 🌀 TẠO CÔNG VIỆC CHO NGÀY KẾ TIẾP (KHI BỊ TỪ CHỐI)
---------------------------------------------- */
export const cloneTask = async (taskData) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/clone`, taskData, buildConfig(taskData));
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Lỗi khi tạo lại công việc";
    console.error(msg, error);
    throw new Error(msg);
  }
};


/* ---------------------------------------------
 📤 GIAO VIỆC CHO NHÂN VIÊN
---------------------------------------------- */
export const assignTask = async (data) => {
  try {
    const formData = new FormData();

    for (const key in data) {
      if (data[key] !== undefined && data[key] !== null && key !== "file") {
        formData.append(key, data[key]);
      }
    }

    // 👇 bắt buộc phải dùng key "file"
    if (data.file) {
      formData.append("file", data.file);
    }

    const res = await axiosInstance.post(`${BASE_URL}/assign`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (error) {
    console.error("❌ assignTask error:", error);
    throw error;
  }
};


/* ---------------------------------------------
 🔍 LẤY NGƯỜI DUYỆT HIỆN TẠI
---------------------------------------------- */
export const getCurrentApprover = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}/current-approver`);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể lấy người duyệt hiện tại";
    console.error(msg, error);
    throw new Error(msg);
  }
};


export const getCurrentApproversBatch = async (ids) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/current-approver/batch`, { ids });
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể lấy danh sách người duyệt";
    console.error(msg, error);
    throw new Error(msg);
  }
};

/* ---------------------------------------------
 📝 PHÊ DUYỆT CÔNG VIỆC
---------------------------------------------- */
export const approveTask = async (id, data = {}) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/${id}/approve`, data);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể duyệt công việc";
    console.error(msg, error);
    throw new Error(msg);
  }
};

/* ---------------------------------------------
 ❌ TỪ CHỐI CÔNG VIỆC
---------------------------------------------- */
export const rejectTask = async (id, data = {}) => {
  if (!id) {
    console.error("❌ rejectTask: Thiếu ID công việc!");
    throw new Error("Không tìm thấy ID công việc để từ chối!");
  }

  try {
    console.log("📡 Gửi API từ chối công việc:", { id, ...data });

    const res = await axiosInstance.post(`${BASE_URL}/${id}/reject`, data);

    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể từ chối công việc";
    console.error("❌ rejectTask lỗi:", msg, error);
    throw new Error(msg);
  }
};


/* ---------------------------------------------
 📄 GỬI BÁO CÁO
---------------------------------------------- */
// export const reportTask = async (id, data) => {
//   try {
//     const res = await axiosInstance.post(`${BASE_URL}/${id}/report`, data, buildConfig(data));
//     return res.data;
//   } catch (error) {
//     const msg = error?.response?.data?.message || "Không thể gửi báo cáo";
//     console.error(msg, error);
//     throw new Error(msg);
//   }
// };

/* ---------------------------------------------
 📄 GỬI BÁO CÁO (HỖ TRỢ MULTI-FILE)
---------------------------------------------- */
export const reportTask = async (id, formData) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/${id}/report`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 120_000,
      }
    );
    return res.data;
  } catch (error) {
    const msg =
      error?.response?.data?.message || "Không thể gửi báo cáo";
    console.error("❌ reportTask error:", msg, error);
    throw new Error(msg);
  }
};

/* ---------------------------------------------
 🔓 BÁO CÁO BỔ SUNG (admin unlock 24h)
---------------------------------------------- */
export const getReportUnlock = async (employee_id, work_day) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/report-unlock`, {
      params: { employee_id, work_day },
    });
    return res.data;
  } catch (error) {
    const msg =
      error?.response?.data?.message || "Không thể kiểm tra mở báo cáo bổ sung";
    console.error("❌ getReportUnlock error:", msg, error);
    throw new Error(msg);
  }
};

export const openReportUnlock = async ({ employee_id, work_day, note } = {}) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/report-unlock`, {
      employee_id,
      work_day,
      note,
    });
    return res.data;
  } catch (error) {
    const msg =
      error?.response?.data?.message || "Không thể mở báo cáo bổ sung";
    console.error("❌ openReportUnlock error:", msg, error);
    throw new Error(msg);
  }
};




/* ---------------------------------------------
 ✅ DUYỆT BÁO CÁO CÔNG VIỆC (approve-report)
---------------------------------------------- */
export const approveReport = async (id, data = {}) => {
  if (!id) {
    console.error("❌ approveReport: Thiếu ID công việc!");
    throw new Error("Không tìm thấy ID công việc để duyệt báo cáo!");
  }

  try {
    console.log("📡 Gửi API duyệt báo cáo:", { id, ...data });

    const res = await axiosInstance.post(`${BASE_URL}/${id}/approve-report`, data, buildConfig(data));
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể duyệt báo cáo công việc";
    console.error("❌ approveReport lỗi:", msg, error);
    throw new Error(msg);
  }
};


/* ---------------------------------------------
 🚫 KHÔNG DUYỆT BÁO CÁO CÔNG VIỆC (reject-report)
---------------------------------------------- */
export const rejectReport = async (id, data = {}) => {
  if (!id) {
    console.error("❌ rejectReport: Thiếu ID công việc!");
    throw new Error("Không tìm thấy ID công việc để không duyệt!");
  }

  try {
    console.log("📡 Gửi API không duyệt báo cáo:", { id, ...data });

    const res = await axiosInstance.post(`${BASE_URL}/${id}/reject-report`, data, buildConfig(data));
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể từ chối báo cáo công việc";
    console.error("❌ rejectReport lỗi:", msg, error);
    throw new Error(msg);
  }
};


/* ---------------------------------------------
 🗑 XÓA TOÀN BỘ CÔNG VIỆC CỦA NHÂN VIÊN THEO NGÀY
---------------------------------------------- */
export const deleteTask = async ({ employee_id, work_day }) => {
  try {
    const res = await axiosInstance.delete(BASE_URL, {
      params: { employee_id, work_day },
    });
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể xóa công việc";
    console.error("❌ Lỗi khi xóa công việc:", msg, error);
    throw new Error(msg);
  }
};


/* -----------------------------------------------------
 🗑 XÓA CÔNG VIỆC THEO NGÀY + TRẠNG THÁI
------------------------------------------------------ */
export const deleteTaskByStatus = async ({ employee_id, work_day, statuses }) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/by-status`, {
      params: { employee_id, work_day, statuses },
    });
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể xóa công việc theo ngày + trạng thái";
    console.error("❌ Lỗi khi xóa công việc theo trạng thái:", msg, error);
    throw new Error(msg);
  }
};


/* ---------------------------------------------
Kiểm tra công việc hôm nay đã hoàn thành hết chưa
---------------------------------------------- */
export const checkTodayTasksCompleted = async (employee_id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/check-today/${employee_id}`);
    return res.data; // { allCompleted: true/false }
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      "Không thể kiểm tra trạng thái công việc hôm nay";
    console.error("❌ Lỗi checkTodayTasksCompleted:", msg, error);
    throw new Error(msg);
  }
};
